import React, {
  forwardRef,
  useEffect,
  useState,
  useMemo,
  useCallback,
} from "react";
import ToolsIntegrationsAPI from "restAPI/ToolsIntegrationAPI";
import { FieldTypes, parseSelectOptions } from "utils/formUtils";
import message from "components/CustomMessage";
import GenericMappingForm from "../GenericMappingForm";
import _ from "lodash";

const HaloSecurityMappingForm = forwardRef(function HaloSecurityMappingForm(
  props,
  ref
) {
  const [targets, setTargets] = useState(() => {
    if (props.record) {
      const { targetId, targetName } = props.record;
      const targetIdArray = targetId.split(",");
      const targetNameArray = targetName.split(",");
      return targetIdArray.map((id, index) => ({
        id,
        name: targetNameArray[index],
      }));
    }
    return [];
  });

  useEffect(() => {
    const { promise, cancel } =
      ToolsIntegrationsAPI.getGenericProjectByToolName(props.toolName, {
        login_id: props.loginConfigId,
      });
    promise
      .then((response) => {
        const { projects } = response;
        setTargets(projects);
      })
      .catch((err) => {
        message.error("Problem fetching targets");
      });

    return cancel;
  }, [props.loginConfigId, props.toolName]);

  const getExtraFieldsData = useCallback((config) => {
    const { targetId } = config;
    const targetNames = _.filter(targets, (project) =>
      targetId.includes(project.id)
    ).map((target) => target.name);

    return {
      targetId: targetId.join(),
      targetName: targetNames.join(),
    };
  }, [targets]);

  const parseExtraFieldsDataFromResponse = useCallback((config) => {
    const { targetId, targetName } = config;
    return {
      targetId: targetId.split(","),
      targetName: targetName.split(","),
    };
  }, []);

  const extraFields = useMemo(
    () => [
      {
        name: "targetId",
        colSpan: "12",
        type: FieldTypes.MULTI_SELECT,
        label: "Target Name",
        options: parseSelectOptions(targets),
        required: true,
        props: {
          autoFocus: true,
        },
      },
    ],
    [targets]
  );

  return (
    <GenericMappingForm
      ref={ref}
      getExtraFieldsData={getExtraFieldsData}
      parseExtraFieldsDataFromResponse={parseExtraFieldsDataFromResponse}
      extraFields={extraFields}
      {...props}
    />
  );
});

export default HaloSecurityMappingForm;
